import React, { Component } from 'react';
import { connect } from 'react-redux';
import withRouter from '../../../lib/router/withRouter';
import { recommendReviewActions } from '../../../store/modules/recommend/review';
import RecommendReviewDetailWrap from '../../../views/recommend/review/detail/RecommendReviewDetailWrap';

class RecommendReviewDetailContainer extends Component {
  componentDidMount() {
    const { match } = this.props;
    if (match.params.id) {
      this.initiate(Number(match.params.id));
    }
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = (recommendReviewId) => {
    const { getRecommendReviewDetail } = this.props;

    getRecommendReviewDetail({
      recommendReviewId,
    });
  };

  render() {
    const { recommendReviewDetail } = this.props;

    return <RecommendReviewDetailWrap recommendReviewDetail={recommendReviewDetail} />;
  }
}

const mapStateToProps = (state) => {
  return {
    recommendReviewDetail: state.recommendReview.recommendReviewDetail,
  };
};

const mapDispatchToProps = {
  getRecommendReviewDetail: recommendReviewActions.getRecommendReviewDetail,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RecommendReviewDetailContainer));
